import React, {Component, Fragment} from 'react';
import CustomLoader from '../common/CustomLoader';
import LoginTemplate from '../template/LoginTemplate'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ReturnIcon from '@material-ui/icons/KeyboardBackspace';
import TextField from '@material-ui/core/TextField';

class LoginPage extends Component {
    constructor(props) {
        super(props);
    };

    state = {
        nickname: '',
        loginStatus: '',
        strError: '',
        isRequested: false,
        account: '',
        password: '',
    };

    verifyAccessToken = () => {
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
        }
        if (accessToken && accessToken.length > 0) {

            fetch('/api/', {
                method: 'post',
                headers: {'Content-type': 'application/json'},
                body: JSON.stringify({
                    data: {
                        category: 'private',
                        service: 'GetUserInformation',
                        access_token: accessToken,
                    }
                })
            }).then(
                res => {
                    // console.log('service', res);
                    if (res) {
                        return res.json();
                    }
                }
            ).then(
                json => {
                    console.log('service OK', json);
                    if (!json) {
                        return;
                    }
                    if (json.err) {
                        console.log('err', json.err);
                        this.setState({
                            loginStatus: 'Login',
                        })
                    } else {
                        // json.data.platform
                        if (json.data.status === 'active') {
                            sessionStorage.setItem('access_info', JSON.stringify(json.data));
                            this.setState({
                                nickname: json.data.nickname,
                                loginStatus: 'LoginCompleted',
                            })
                        } else {
                            this.setState({
                                loginStatus: 'Login',
                            })
                        }
                    }
                }).catch(
                err => {
                    console.log(err)
                    this.setState({
                        loginStatus: 'Login',
                    });
                }
            );
        } else {
            this.setState({
                loginStatus: 'Login',
            });
        }
    };

    requestSignIn = () => {
        this.setState({
            isRequested: true,
        });
        fetch('/api/', {
            method: 'post',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify({
                data: {
                    category: 'public',
                    service: 'SignIn',
                    account: this.state.account,
                    password: this.state.password,
                }
            })
        }).then(res => {
            console.log('service', res);
            if (res) {
                return res.json();
            }
        }).then(json => {
            if (!json) {
                return;
            }
            this.setState({
                isRequested: false,
            });
            if (json.err) {
                this.setState({
                    strError: json.err,
                });
            } else {
                sessionStorage.setItem('access_info', JSON.stringify(json.data));

                this.setState({
                    nickname: json.data.nickname,
                    loginStatus: 'LoginCompleted',
                    strError: '',
                })
            }
        }).catch(err => {
            console.log(err);
        });
    };

    handleFormEvent = (e, status) => {
        e.preventDefault();
        if (this.state.isRequested) {
            return;
        }
        const {loginStatus} = this.state;
        const { requestSignIn } = this;

        let nextStatus = status;
        let sendData = null;

        if (loginStatus === 'GetUserStatus') {
            sendData = {
                category: 'public',
                service: 'GetUserStatus',
                account: this.state.account,
            };
        } else if (loginStatus === 'SignIn') {
            requestSignIn();
            return;
        }

        this.setState({
            isRequested: true,
        });
        fetch('/api/', {
            method: 'post',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify({
                data: sendData
            })
        }).then(res => {
            console.log('service', res);
            if (res) {
                return res.json();
            }
        }).then(json => {
            if (!json) {
                return;
            }
            // console.log('service OK 1', send_data.service, json);
            // let start = new Date().getTime();
            // while (new Date().getTime() < start + 3000);

            this.setState({
                isRequested: false,
            });
            if (json.err) {
                console.log('service 실패', sendData.service, status, json);
                this.setState({
                    strError: json.err,
                });
            } else {
                console.log('서비스 호출 성공', sendData.service, status, json);
                if (loginStatus === 'GetUserStatus') {
                    this.setState({
                        loginStatus: nextStatus,
                        strError: '',
                    })
                }  else {
                    console.log('service OK 3', sendData.service, json);
                    // json.data.platform
                    this.setState({
                        loginStatus: nextStatus,
                        strError: '',
                    })
                }
            }
        }).catch(err => {
            console.log(err);
        });
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    };

    componentDidMount() {
        const {verifyAccessToken} = this;
        verifyAccessToken()
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {loginStatus} = nextState;

        if (loginStatus === 'LoginCompleted') {
            if (nextState.isRequested === false) {
                this.props.login({
                    account: nextState.account,
                    nickname: nextState.nickname,
                });
                return false
            }
        }
        return true
    };

    render() {
        let inputArea = null;

        const {loginStatus} = this.state;
        const {handleChange, handleFormEvent} = this;
        switch (loginStatus) {
            case 'SignIn':
                inputArea = <Fragment>
                    {this.state.isRequested ?
                        <div className={'loading'}>
                            <CustomLoader/>
                        </div> :
                        <form onSubmit={(e) => handleFormEvent(e, 'LoginCompleted')}>
                            <TextField
                                error={this.state.strError.length > 0}
                                helperText={this.state.strError.length > 0 ? '비밀번호가 일치하지 않습니다' : '비밀번호를 입력하세요'}
                                key="outlined-password-input"
                                id="outlined-password-input"
                                className='signin-input'
                                label="Password"
                                type="password"
                                name="password"
                                autoComplete="current-password"
                                margin="normal"
                                variant="outlined"
                                onChange={handleChange}
                                autoFocus
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                className='signin-button'
                                onClick={(e) => handleFormEvent(e, 'LoginCompleted')}>
                                로그인
                            </Button>
                            <IconButton
                                color="primary"
                                className={'back-button'}
                                aria-label="Back"
                                onClick={() => this.setState({strError: '', loginStatus: 'GetUserStatus'})}>
                                <ReturnIcon/>
                            </IconButton>
                        </form>
                    }
                </Fragment>;
                break;
            case 'GetUserStatus':
                inputArea = <Fragment>
                    {this.state.isRequested ?
                        <div className={'loading'}>
                            <CustomLoader/>
                        </div> :
                        <form onSubmit={(e) => handleFormEvent(e, 'SignIn')}>
                            <TextField
                                error={this.state.strError.length > 0}
                                helperText={this.state.strError.length > 0 ? '존재하지 않는 아이디입니다' : '아이디를 입력하세요'}
                                key="outlined-account-input"
                                id="outlined-account-input"
                                className='signin-input'
                                label="아이디"
                                name="account"
                                margin="normal"
                                variant="outlined"
                                value={this.state.account}
                                onChange={handleChange}
                                autoFocus
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                className='signin-button'
                                // className={classes.button}
                                onClick={(e) => handleFormEvent(e, 'SignIn')}>
                                다음
                            </Button>
                            <IconButton
                                color="primary"
                                className={'back-button'}
                                aria-label="Back"
                                onClick={() => this.setState({strError: '', loginStatus: 'Login'})}>
                                <ReturnIcon/>
                            </IconButton>
                        </form>
                    }
                </Fragment>;
                break;
            case 'Login':
                inputArea = <Fragment>
                    <div className='init-button-padding'/>
                    <Button
                        variant="contained"
                        color="primary"
                        className='signin-button'
                        // className={classes.button}
                        onClick={() => this.setState({loginStatus: 'GetUserStatus'})}>
                        로그인
                    </Button>
                </Fragment>;
                break;
            default:
                inputArea = <Fragment>
                    <CustomLoader/>
                </Fragment>;
                break;
        }


        return <LoginTemplate inputArea={inputArea}>
        </LoginTemplate>
    }

}

export default LoginPage;